import { render, staticRenderFns } from "./Trespasos.vue?vue&type=template&id=47a394ce&scoped=true&"
import script from "./Trespasos.vue?vue&type=script&lang=js&"
export * from "./Trespasos.vue?vue&type=script&lang=js&"
import style0 from "./Trespasos.vue?vue&type=style&index=0&id=47a394ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a394ce",
  null
  
)

export default component.exports